import { Link, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../../configurations/axiosInstance/AxiosInstance";
import React, { useContext, useEffect, useState } from "react";
import { Breadcrumb, Button, Col, Empty, message, Row, Space, Spin, Tag, Tooltip, Card, Avatar, Descriptions, Image, Badge } from "antd";
import TableTemplate from "../../../components/table";
import { useSelector } from "react-redux";
import BreadCom from "../../../components/breadCom/BreadCom";
import { useRole, useTitle } from "../../../configurations/utils/Utils";
import { LoadingContext } from "../../../composants/loadingContext";
import { FormattedMessage, useIntl } from "react-intl";
import { PictureOutlined, CheckCircleOutlined, CloseCircleOutlined, AppstoreOutlined, FileImageOutlined } from '@ant-design/icons';
import * as Utils from '../../../composants/utils/utils';

export default function ViewGallery() {
    const { accessToken } = useSelector(state => state.authUser);
    const params = useParams();
    const nav = useNavigate();
    const [slide, setSlide] = useState(null);
    const intL = useIntl();
    const { loading, setLoading } = useContext(LoadingContext);
    useRole([Utils.PERMISSIONS.GET_SLIDER.value]);
    useTitle('View Gallery');
    const navigation = (link) => {
        setLoading(true);
        nav(link);
        setLoading(false);
    }
    const getSlideById = () => {
        axiosInstance(accessToken).get('api/gallery/' + params.id)
            .then(
                (response) => {
                    setSlide(response.data);
                    setLoading(false);
                }
            ).catch(
                (error) => {
                    message.error("Error");
                    setSlide(null);
                    setLoading(false);
                }
            );
    }


    useEffect(
        () => {
            setLoading(true)
            getSlideById();
        }, []
    )


    const returnValue = slide == null ? <>
        <Spin spinning={loading}>
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Aucun Fichier trouvé"
                style={{ padding: '60px 0' }}
            />
        </Spin>
    </> : <>
        <Row gutter={[24, 24]}>
            {/* Colonne gauche - Image */}
            <Col xs={24} lg={12}>
                <Card
                    bordered={false}
                    style={{
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        height: '100%'
                    }}
                >
                    <div style={{ marginBottom: '16px' }}>
                        <Space align="center" size={12}>
                            <FileImageOutlined style={{ fontSize: '24px', color: '#667eea' }} />
                            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                                Aperçu de l'image
                            </h3>
                        </Space>
                    </div>

                    <div style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderRadius: '12px',
                        padding: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '400px'
                    }}>
                        {
                            slide.type === 'VIDEO' && (
                                <video src={slide.path} controls style={{ width: '100%', maxHeight: '500px', borderRadius: '8px' }} />
                            )
                        }
                        {
                            slide.type === 'AUDIO' && (
                                <audio src={slide.path} controls style={{ width: '100%', maxHeight: '500px', borderRadius: '8px' }} />
                            )
                        }
                        {
                            slide.type === 'IMAGE' && (
                                <Image
                                    src={slide.path}
                                    alt={slide.title}
                                    style={{
                                        borderRadius: '8px',
                                        maxHeight: '500px',
                                        objectFit: 'contain'
                                    }}
                                    preview={{
                                        mask: <div>🔍 Agrandir</div>
                                    }}
                                />)
                        }
                    </div>
                </Card>
            </Col>

            {/* Colonne droite - Informations */}
            <Col xs={24} lg={12}>
                <Space direction="vertical" size={16} style={{ width: '100%' }}>
                    {/* Card Titre */}
                    <Card
                        bordered={false}
                        style={{
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                        }}
                    >
                        <div style={{ color: 'white' }}>
                            <div style={{ fontSize: '13px', opacity: 0.9, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                <FormattedMessage id="title" />
                            </div>
                            <div style={{ fontSize: '24px', fontWeight: '600', lineHeight: '1.3' }}>
                                {slide.title == null ? intL.formatMessage({ id: 'empty' }) : slide.title}
                            </div>
                        </div>
                    </Card>

                    {/* Card Message */}
                    <Card
                        bordered={false}
                        style={{
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}
                    >
                        <Space direction="vertical" size={8} style={{ width: '100%' }}>
                            <div style={{ fontSize: '13px', color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                <FormattedMessage id="messagePlaceholder" />
                            </div>
                            <div style={{
                                fontSize: '15px',
                                color: '#595959',
                                lineHeight: '1.8',
                                padding: '12px',
                                background: '#fafafa',
                                borderRadius: '8px',
                                minHeight: '80px'
                            }}>
                                {slide.description == null || slide.description.toString().trim().length == 0
                                    ? <span style={{ color: '#bfbfbf', fontStyle: 'italic' }}>{intL.formatMessage({ id: 'empty' })}</span>
                                    : slide.description}
                            </div>
                        </Space>
                    </Card>
                    {
                        (slide.type === 'VIDEO' || slide.type === 'AUDIO') && (
                            <Card
                                bordered={false}
                                style={{
                                    borderRadius: '12px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                }}
                            >
                                <div style={{ color: 'white' }}>
                                    <div style={{ fontSize: '13px', opacity: 0.9, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        <FormattedMessage id="duree" />
                                    </div>
                                    <div style={{ fontSize: '24px', fontWeight: '600', lineHeight: '1.3' }}>
                                        {slide.duree}
                                    </div>
                                </div>
                            </Card>
                        )
                    }


                    {/* Card Taille */}
                    <Card
                        bordered={false}
                        style={{
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}
                    >
                        <Space direction="vertical" size={8} style={{ width: '100%' }}>
                            <div style={{ fontSize: '13px', color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                <FormattedMessage id="taille" />
                            </div>
                            <div>
                                {slide.taille} Byte
                            </div>
                        </Space>
                    </Card>

                    {/* Card Statut */}
                    <Card
                        bordered={false}
                        style={{
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}
                    >
                        <Space direction="vertical" size={8} style={{ width: '100%' }}>
                            <div style={{ fontSize: '13px', color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                <FormattedMessage id="status" />
                            </div>
                            <div>
                                {slide.active ? (
                                    <Tag
                                        icon={<CheckCircleOutlined />}
                                        color="success"
                                        style={{
                                            fontSize: '15px',
                                            padding: '6px 16px',
                                            borderRadius: '8px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        <FormattedMessage id="enable" />
                                    </Tag>
                                ) : (
                                    <Tag
                                        icon={<CloseCircleOutlined />}
                                        color="error"
                                        style={{
                                            fontSize: '15px',
                                            padding: '6px 16px',
                                            borderRadius: '8px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        <FormattedMessage id="disable" />
                                    </Tag>
                                )}
                            </div>
                        </Space>
                    </Card>

                    {/* Card Application cible */}
                    <Card
                        bordered={false}
                        style={{
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}
                    >
                        <Space direction="vertical" size={8} style={{ width: '100%' }}>
                            <div style={{
                                fontSize: '13px',
                                color: '#8c8c8c',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}>
                                <AppstoreOutlined />
                                Type de fichier
                            </div>
                            <div style={{
                                fontSize: '16px',
                                fontWeight: '500',
                                color: '#262626',
                                padding: '8px 12px',
                                background: '#f5f5f5',
                                borderRadius: '6px',
                                borderLeft: '3px solid #667eea'
                            }}>
                                {slide.type == null || slide.type.toString().trim().length == 0
                                    ? intL.formatMessage({ id: 'empty' })
                                    : slide.type}
                            </div>
                        </Space>
                    </Card>

                </Space>
            </Col>
        </Row>
    </>
    const breadCum = [
        {
            id: 0,
            last: false,
            path: '/admin/gallery',
            name: 'Gallery',
        },
        {
            id: 1,
            last: true,
            path: params.id,
            name: params.id,
        }
    ];
    return (
        <>
            <BreadCom name={"Slider info"} data={breadCum} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <section className="col-lg-12">
                            <div className="card card-primary" style={{ background: '#ffffff00' }}>
                                <div className="card-header">
                                    <h3 className="card-title">
                                        <i className="fas fa-chart-pie mr-1"></i>
                                        Detail
                                    </h3>
                                </div>
                                <div className="card-body">
                                    <div className="tab-content p-0">
                                        {returnValue}
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </section>
        </>
    );
}